/**
 * Requires
 */

import $ from 'jquery'
import { trackEvent } from './utils/analytics'

/**
 * Initialisation
 */

export function initialise() {
  if (window.disableAutoTargetLinks) {
    return
  }

  // Open external links and PDFs in new window
  $(document).on('click', 'a, area', function() {
    const href = $(this).attr('href')
    if (
      href &&
      !this.target &&
      ((href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)) || href.match(/\.(pdf|docx?|xlsx?)$/i))
    ) {
      this.target = '_blank'
      this.rel = 'noopener noreferrer'
    }
  })

  // Track document links
  $(document).on('click', 'a, area', function() {
    const label = ($(this).text() || $(this).attr('aria-label') || $(this).attr('title') || '').trim()
    const href = $(this).attr('data-filename') || $(this).attr('href')
    if (href && href.match(/\.(pdf|docx?|xlsx?)$/i)) {
      trackEvent('Downloads', label, href)
    } else if (href && href.indexOf(window.location.hostname) == -1 && href.match(/^https?/i)) {
      trackEvent('Outbound Link', label, href)
    }
  })
}
